import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const messagesSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        //reducers here
    },
});

export const {} = messagesSlice.actions;
export default messagesSlice.reducer;
